import PageHandler from "./PageHandler";
import Pages from "Pages";

class LicensesListPageHandler extends PageHandler {
  constructor() {
    super("licenses-list", Pages.LicensesListPage);
  }

  async fetch(parameters) {
    this.rootStore.data.LicensesStore.fetchByCustomerId(parameters.customerId);

    // Also fetch the applications
    this.rootStore.data.ApplicationsStore.fetch();

    // Fetch customer that owns the licenses
    let customer = this.rootStore.data.CustomersStore.findById(
      parameters.customerId
    );
    if (!customer)
      this.rootStore.data.CustomersStore.fetchId(parameters.customerId);

    // Fetch licenses in use
    this.rootStore.data.LicensesInUseStore.fetchByCustomerId(
      parameters.customerId
    );
  }
}

export default LicensesListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/LicensesListPageHandler.js